import { render, staticRenderFns } from "./Lead.vue?vue&type=template&id=181c8f28&scoped=true&"
import script from "./Lead.vue?vue&type=script&lang=js&"
export * from "./Lead.vue?vue&type=script&lang=js&"
import style0 from "./Lead.vue?vue&type=style&index=0&id=181c8f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181c8f28",
  null
  
)

export default component.exports